import {Component, Vue} from 'vue-property-decorator';
import Spinner from 'vue-simple-spinner';
import OverlaySpinner from '@/components/OverlaySpinner.vue';
import axios from 'axios';
import {BadEntityError} from '@/errors/BadEntityError';

@Component({
    components: {
        Spinner,
        OverlaySpinner
    }
})
export default class LoadingMixin extends Vue {
    protected loading = false;
    protected saving = false;

    protected cardDataErrors = {};

    protected async execute(run: () => Promise<any>, defaultMessage: string): Promise<boolean> {
        let success = true;
        try {
            this.loading = true;
            await run();
        } catch (e) {
            if (axios.isCancel(e)) {
                // Do nothing
            } else {
                this.$notifyError(e, defaultMessage);
            }
            success = false;
        }
        this.loading = false;
        return success;
    }

    protected async save(run: () => Promise<any>, defaultMessage: string): Promise<boolean> {
        let success = true;
        try {
            this.saving = true;
            this.cardDataErrors = {};
            await run();
        } catch (e) {
            if (axios.isCancel(e)) {
                // Do nothing
            } else if (e instanceof BadEntityError) {
                this.cardDataErrors = e.errors;
            } else {
                this.$notifyError(e, defaultMessage);
            }
            success = false;
        }
        this.saving = false;
        return success;
    }
}
